module.exports = __webpack_public_path__ + "media/tefballvid.8bb60c55.mp4";